export default {"src":"https://s.sylndr.com/c-960f75c/_next/static/media/vector.6cfe0b13.svg","height":436,"width":414,"blurWidth":0,"blurHeight":0};